module.exports = __webpack_public_path__ + "static/media/clermont.0ce7df35.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/clermont.png
// module id = 93
// module chunks = 0